import styled from 'styled-components';

export const StyledButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
`;
